import React from "react";

import { Splide, SplideSlide } from "@splidejs/react-splide";
import "@splidejs/react-splide/css";

import Section from "@coninsa-s2/section";
import Container from "@coninsa-s2/container";
import Banner from "@coninsa-s2/banner";
import Heading from "@coninsa-s2/heading";
import Button from "@coninsa-s2/button";
import Card from "@coninsa-s2/card";
import Title from "@coninsa-s2/title";
import { arrowPath } from "@coninsa-s2/slider";

import welfareBanner from "./images/banner.jpg";
import welfareMobileBanner from "./images/mobile-banner.jpg";
import welfareVideo from "./images/welfare-video.jpg";
import welfareImg from "./images/welfare.jpg";
import welfareMobileImg from "./images/mobile-welfare.jpg";
import goalWelfareImg from "./images/goal-welfare.jpg";
import goalWelfareMobileImg from "./images/goal-welfare-mobile.jpg";
import cardOneImg from "./images/card-one.jpg";
import cardTwoImg from "./images/card-two.jpg";
import cardThreeImg from "./images/card-three.jpg";

import ArrowRightIcon from "../home/icons/arrow-right.inline.svg";
import PinIcon from "../../design/feature-item/icons/pin.inline.svg";
import projects from "./projects";

const data = [
  {
    id: "item-1",
    tag: "Servicios de",
    title: "arrendamientos, y venta de usados",
    description:
      "Encuentra tu inmueble ideal de comercio o vivienda más de 2000 inmuebles para conocer.",
    url: "/arrendamientos",
    tint: "lime",
  },
  {
    id: "item-2",
    tag: "Portafolio de proyectos",
    title: "nuevos de vivienda, comercio e industria",
    description:
      "Explora nuestra sección de proyectos y encuentra el lugar ideal para vivir o invertir.",
    url: "/proyectos",
    tint: "green",
  },
  {
    id: "item-3",
    tag: "Servicios de diseño",
    title: "arquitectónico y técnico",
    description:
      "Nuestros servicios van desde el diseño urbanístico hasta el arquitectónico y de interiorismo.",
    url: "/arquitectura",
    tint: "teal",
  },
  {
    id: "item-4",
    tag: "Servicios de construcción",
    title: "de edificaciones e infraestructura",
    description:
      "Ofrecemos soluciones innovadoras y competitivas como respuesta a sus necesidades.",
    url: "/construccion",
    tint: "dark-blue",
  },
];

const cards = [
  {
    id: "card-1",
    image: cardOneImg,
    url: "https://youtube.com/shorts/NPFRD_gsuUI?feature=share",
    alt: "Bienestar en Coninsa",
    title: "La vida se mide en bienestar",
  },
  {
    id: "card-1",
    image: cardTwoImg,
    url: "https://youtube.com/shorts/oN3aSvj4EOc",
    alt: "Trabajadora de coninsa",
    title: "Asesoria personalizada para ti",
  },
  {
    id: "card-1",
    image: cardThreeImg,
    url: "https://www.youtube.com/shorts/_h2KsdwZKZQ",
    alt: "Watana vega",
    title: "Watana vega",
  },
];

const sliderOptions = {
  arrows: false,
  gap: 0,
  padding: { left: 0, right: "0" },
  perPage: 3,
  pagination: false,
  breakpoints: {
    640: {
      arrows: false,
      gap: 0,
      perPage: 1,
      padding: { left: 0, right: "2.5rem" },
    },
  },
};

const projectSliderOptions = {
  arrowPath: arrowPath,
  arrows: true,
  gap: 0,
  padding: { left: 0, right: "200px" },
  perPage: 3,
  pagination: false,
  breakpoints: {
    640: {
      arrows: false,
      gap: 0,
      perPage: 1,
      padding: { left: 0, right: "2.5rem" },
      pagination: true,
    },
  },
};

export default function Welfare() {
  return (
    <>
      <div>
        <Banner
          className=""
          imageUrl={welfareBanner}
          imageUrlMobile={welfareMobileBanner}
        >
          <Container className="">
            <h1 className="max-sm:pt-4 lg:pr-44 lg:font-semibold text-s2-teal text-xl lg:text-2xl text-center lg:text-right">
              La{" "}
              <span className="font-extrabold text-4xl lg:text-5xl">vida</span>{" "}
              no se mide en m²,
              <br />{" "}
              <span className="lg:pr-28 max-sm:text-center">se mide en</span>
              <span className="block lg:pr-14 font-extrabold text-4xl">
                bienestar
              </span>
            </h1>
          </Container>
        </Banner>
      </div>

      <Section>
        <Container>
          <div className="lg:items-center gap-4 lg:grid lg:grid-cols-2">
            <img
              className="max-sm:mb-6 rounded-xl"
              src={welfareVideo}
              alt="Welfare video image"
            />

            <div>
              <Heading
                as="h2"
                size="4xl"
                className="mb-4 lg:mb-2 !font-normal max-sm:!text-3xl text-balance lg:!leading-[50px]"
              >
                En Coninsa la vida no se mide en m², <br />
                <span className="font-bold !text-s2-teal">
                  se mide en bienestar
                </span>
              </Heading>
              <p className="mb-5">
                Durante más de cinco décadas hemos acompañado miles de historias
                llenas de sueños cumplidos, emociones compartidas y momentos que
                trascienden. Hemos transformado espacios en lugares que generan
                bienestar, construyendo no solo proyectos, sino futuros llenos
                de oportunidades para quienes confían en nosotros.
              </p>

              <Button
                href="https://www.youtube.com/watch?v=wPhVxy1QxeM"
                target="_blank"
              >
                Ver video
              </Button>
            </div>
          </div>
        </Container>
      </Section>
      <div>
        <img
          src={welfareImg}
          alt="Coninsa en el tiempo"
          className="max-sm:hidden w-full h-[800px]"
        />
        <img
          src={welfareMobileImg}
          alt="Coninsa en el tiempo"
          className="lg:hidden"
        />
      </div>
      <Section tint="light-gray">
        <Container>
          <p className="mb-10 lg:text-xl text-center">
            En Coninsa entendemos que{" "}
            <span className="font-bold">
              la vida no se mide en metros cuadrados, se mide en bienestar
            </span>
            . Por eso hemos creado un ecosistema que brinda soluciones
            integrales para el hábitat. Nuestros diferentes servicios están
            pensados para acompañarte en tus metas, impulsar tus sueños y
            ofrecerte espacios que inspiren progreso y calidad de vida.
          </p>
          <div className="gap-4 grid md:grid-cols-2 lg:grid-cols-4">
            {data.map((item) => (
              <Card key={item.id} tint={item.tint} className="my-8 p-8">
                <Title tint="" size="2xl" condensed>
                  {item.tag} <br />
                  <span className={`text-s2-${item.tint} is-highlighted`}>
                    arrendamientos, y venta de usados
                  </span>
                </Title>
                <p>
                  Ofrecemos soluciones innovadoras y competitivas como respuesta
                  a sus necesidades.
                </p>
                <Button href={item?.url} target="_blank">
                  Conoce más
                </Button>
                <a href={item?.url} target="_blank" title={item?.subtitle}>
                  <ArrowRightIcon className="s2-card__content-icon" />
                </a>
              </Card>
            ))}
          </div>
        </Container>
      </Section>

      <Section>
        <Container>
          <Heading
            as="h2"
            size="4xl"
            className="mb-4 lg:mb-10 !font-normal max-sm:!text-3xl text-center lg:!leading-[50px]"
          >
            Algunos de{" "}
            <span className="font-bold !text-s2-teal">nuestros proyectos</span>
          </Heading>

          <Splide
            options={projectSliderOptions}
            className="flex justify-center s2-slider s2-slider--lg"
          >
            {projects.map((project) => (
              <SplideSlide key={project.id}>
                <div className="px-2 pb-4 h-full">
                  <div key={project.id} className="">
                    <img
                      src={project.image}
                      alt={project.title}
                      title={project.title}
                      className="rounded-t-lg"
                    />
                    <div className="bg-s2-white shadow-md p-4 lg:p-5 rounded-b-lg h-36 lg:h-44">
                      <div className="font-bold text-lg lg:text-xl leading-6">
                        {project.title}
                      </div>
                      <p className="mb-2 lg:mb-3 max-sm:text-sm">
                        {project.description}
                      </p>
                      <div className="flex gap-1">
                        <PinIcon className="w-5" />
                        <p className="font-semibold max-sm:text-sm">
                          {project.location}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </SplideSlide>
            ))}
          </Splide>
        </Container>
      </Section>

      <Section tint="dark-blue">
        <Container>
          <Heading
            as="h2"
            size="4xl"
            className="mb-4 lg:mb-10 !font-normal !text-s2-white max-sm:!text-3xl text-center text-balance lg:!leading-[50px]"
          >
            <span className="font-bold">
              Historias de Confianza: <br />
            </span>
            Nuestros Clientes y Proyectos
          </Heading>

          <Splide options={sliderOptions} className="flex justify-center">
            {cards.map((card) => (
              <SplideSlide key={card.id}>
                <div className="px-2 h-full">
                  <div
                    key={card.id}
                    className="relative bg-s2-white p-4 lg:p-5 rounded-xl lg:w-[350px]"
                  >
                    <img src={card.image} alt={card.alt} title={card.title} />
                    <div className="flex justify-center">
                      <Button
                        href={card.url}
                        target="_blank"
                        inverted
                        className="bottom-10 lg:bottom-16 z-20 absolute !bg-white hover:!bg-s2-dark-blue"
                      >
                        Ver video
                      </Button>
                    </div>
                  </div>
                </div>
              </SplideSlide>
            ))}
          </Splide>
        </Container>
      </Section>
      <div>
        <img
          src={goalWelfareMobileImg}
          alt="La vida se mide en bienestar"
          className="lg:hidden"
        />
        <img
          src={goalWelfareImg}
          alt="La vida se mide en bienestar"
          className="max-sm:hidden w-full"
        />
      </div>
    </>
  );
}
